import React, {useEffect, useState} from 'react';
import {useParams} from "react-router";
import {Box, Skeleton, Typography} from "@mui/material";
import projectApi from 'src/api/project/project.ts';
import HtmlContent from "src/components/HtmlContent";
import ProjectCard from "src/components/project/ProjectCard";

const ProjectDetailPage = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);

  const fetchProject = async () => {
    const fetchedProject = await projectApi.retrieveItem(id);
    setProject(fetchedProject);
  }

  useEffect(() => {
    fetchProject();
  }, [])

  if (!project) {
    return <Skeleton variant="rectangular" height="500px" />;
  }

  return (
    <>
      <Typography variant="h2" mb={2}>{project.name}</Typography>

      <Box mb={2}>
        <HtmlContent html={project.description}/>
      </Box>

      <Box mb={2}>
        {
          (project && project.image)
            ? <img src={project.image.contentUrl} alt="project image" />
            : <Skeleton variant="rectangular" height="300px"></Skeleton>
        }
      </Box>

      <ProjectCard project={project} projectDetailVersion/>
    </>
  );
}

export default ProjectDetailPage;

ProjectDetailPage.propTypes = {}

ProjectDetailPage.defaultProps = {}